module.exports = __webpack_public_path__ + "az.svg?c9be60f969d3e5ccb0e4da8fc217cbc5";